/**
 * Cloud Account Type
 */
export type CloudAccountType = {
  id: string;
  name: string;
  platform: string;
  applications?: ApplicationType[];
  status: string;
  environment: string;
  source?: string;
};

export type ApplicationType = {
  applicationId: number;
  name: string;
  description: string;
};

export type UsersCloudAccountType = {
  identity: {
    user: {
      resources: {
        applicationsPaged: {
          totalCount?: number;
          applications: ApplicationType[];
        };
      };
      cloudAccounts: CloudAccountType[];
    };
  };
};
export enum AssociateAccountType {
  BUTTON = 'button',
  CARD = 'card',
}
